import { API_URLS } from '@helpers/api';
import { PASSWORD_RULE, PASSWORD_RULES } from '@helpers/utils';
import { useForm } from '@hooks/useForm';
import Button from '@stories/Components/Buttons/Button/Button';
import TextField from '@stories/Components/FormFields/TextField/TextField';
import Accordion from '@stories/Components/Misc/Accordion/Accordion';
import ErrorArea from '@stories/Components/Misc/ErrorArea/ErrorArea';
import * as React from 'react';
import ProfileIntroduction from '@stories/Widgets/AccountArea/ProfileIntroduction/ProfileIntroduction';
import ProfileTabs from '@stories/Widgets/AccountArea/ProfileTabs/ProfileTabs';
import S from './ChangePassword.styles';
const FIELD_COUNT = 3;
const ChangePassword = (props) => {
    const { refContainer, status: formStatus, confirmationMessage, serverErrors, validationErrors, onSubmit, useReactHookFormReturn: { register, getValues, formState: { errors, dirtyFields }, }, } = useForm({
        defaultValues: {},
        endpoint: API_URLS.SUBMIT_CHANGE_PASSWORD,
        mode: 'json',
    });
    React.useEffect(() => {
        if (confirmationMessage) {
            return refContainer.current?.scrollIntoView({
                behavior: 'smooth',
                block: 'start',
                inline: 'start',
            });
        }
    }, [confirmationMessage]);
    const renderErrorMessage = (error, serverFieldErrorName) => {
        const fieldErrorByName = validationErrors.find((x) => x.fieldName === serverFieldErrorName);
        // Checks if sever field error exists by name and returns message.
        if (fieldErrorByName) {
            return { ...error, message: fieldErrorByName.errorMessage };
        }
        // Returns client-side field error message.
        return { ...error, message: error?.message };
    };
    return (React.createElement(S.Container, { id: props.anchorId },
        React.createElement(ProfileIntroduction, { title: props.title, message: props.introduction ?? '', supportCard: props.supportCard, progress: Object.keys(dirtyFields).length > 0
                ? /* Progress value counts for 33% of the growth of the circle, as fields get completed it will grow */
                    (Object.keys(dirtyFields).length / FIELD_COUNT) * 0.33
                : 0 }),
        React.createElement(ProfileTabs, { currentPage: props.currentPage, tabCta: props.tabCta }),
        formStatus === 'fulfilled' && confirmationMessage ? (React.createElement(S.Confirmation, null, confirmationMessage)) : (!props.invalidRequest && (React.createElement("div", { ref: refContainer },
            React.createElement(S.Form, { onSubmit: onSubmit },
                serverErrors && serverErrors.length > 0 ? (React.createElement(ErrorArea, { validationErrors: serverErrors })) : null,
                validationErrors && validationErrors.length > 0 ? (React.createElement(ErrorArea, { validationErrors: validationErrors
                        .filter((x) => x.errorTypeName === 'errorTypeName')
                        .map((x) => x.errorMessage ?? '') })) : null,
                React.createElement(S.FormSection, null,
                    React.createElement(TextField, { dirty: dirtyFields.currentPassword ?? false, label: "Current password", placeholder: "Current password", error: renderErrorMessage(errors.currentPassword, 'CurrentPassword'), type: "password", required: true, inputProps: register('currentPassword', {
                            pattern: PASSWORD_RULE,
                            required: props.requiredPasswordError,
                        }) }),
                    React.createElement(TextField, { dirty: dirtyFields.password ?? false, label: "Enter new password", placeholder: "New password", error: renderErrorMessage(errors.password, 'Password'), type: "password", required: true, inputProps: register('password', {
                            pattern: PASSWORD_RULE,
                            required: props.requiredPasswordError,
                        }) }),
                    React.createElement(TextField, { dirty: dirtyFields.confirmPassword ?? false, label: "Confirm new password", placeholder: "Confirm password", error: renderErrorMessage(errors.confirmPassword, 'ConfirmPassword'), type: "password", required: true, inputProps: register('confirmPassword', {
                            validate: {
                                matchesPreviousPassword: (value) => {
                                    const { password } = getValues();
                                    return password === value || 'Please ensure the passwords match';
                                },
                            },
                        }) }),
                    React.createElement("div", null,
                        React.createElement(Button, { buttonType: "orange-solid", type: "submit" }, "Confirm Password")),
                    React.createElement(Accordion, { initialId: 'password_rules' },
                        React.createElement(Accordion.Item, { id: "password_rules", title: "Password Requirements" },
                            React.createElement(S.Content, null,
                                React.createElement("ul", null, PASSWORD_RULES.map((rule, index) => (React.createElement("li", { key: `password-rule-${index}` }, rule))))))))))))));
};
export default ChangePassword;
